module.exports = __webpack_public_path__ + "img/people.83ef79fd.svg";